var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H19V8C19 9.10457 18.1046 10 17 10H7C5.89543 10 5 9.10457 5 8V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16C5 14.8954 5.89543 14 7 14H17C18.1046 14 19 14.8954 19 16V22H5V16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 9.60005L5.46667 11.6001C5.73333 11.8001 5.73333 12.2001 5.46667 12.4001L2.8 14.4001C2.47038 14.6473 2 14.4121 2 14.0001V10.0001C2 9.58803 2.47038 9.35284 2.8 9.60005Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5333 11.6001L21.2 9.60005C21.5296 9.35284 22 9.58803 22 10.0001V14.0001C22 14.4121 21.5296 14.6473 21.2 14.4001L18.5333 12.4001C18.2667 12.2001 18.2667 11.8001 18.5333 11.6001Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25C7.08579 11.25 6.75 11.5858 6.75 12C6.75 12.4142 7.08579 12.75 7.5 12.75H8.625C9.03921 12.75 9.375 12.4142 9.375 12C9.375 11.5858 9.03921 11.25 8.625 11.25H7.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 11.25C10.4608 11.25 10.125 11.5858 10.125 12C10.125 12.4142 10.4608 12.75 10.875 12.75H13.125C13.5392 12.75 13.875 12.4142 13.875 12C13.875 11.5858 13.5392 11.25 13.125 11.25H10.875Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11.25C14.9608 11.25 14.625 11.5858 14.625 12C14.625 12.4142 14.9608 12.75 15.375 12.75H16.5C16.9142 12.75 17.25 12.4142 17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25H15.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBreak);
export default __webpack_public_path__ + "static/media/page-break.5a38cb22769be9eb5d927e6b848b7a50.svg";
export { ForwardRef as ReactComponent };